import React, { useEffect, useState } from "react";
import { Row, Col, Spin, Card, Typography, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { useDispatch, useSelector } from "react-redux";
import { doctorListInProgress } from "../../../appRedux/doctor/actions/doctor";
import TableComponent from "../../../components/Table/TableComponent";

const DoctorList = ({ selectedDoctorId, onDoctorSelect }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const doctorListData = useSelector((state) => state?.doctorList?.doctorList);
  const doctorList = doctorListData?.data?.data;

  const handleDoctorSelect = (record) => {
    if (onDoctorSelect) {
      onDoctorSelect(record.id);
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Designation",
      dataIndex: "designation_name",
      key: "designation_name",
    },
    {
      title: "Specialization",
      dataIndex: "specialization_name",
      key: "specialization_name",
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => (
        <Row className="table-button">
          <Col className="button-edit">
            {selectedDoctorId === record.id ? (
              <ButtonComponent
                className={"secondary-color"}
                label={"Selected Doctor"}
                onClick={() => handleDoctorSelect(record)}
              />
            ) : (
              <ButtonComponent
                type="primary"
                label={"Select Doctor"}
                onClick={() => handleDoctorSelect(record)}
              />
            )}
          </Col>
        </Row>
      ),
    },
  ];

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );

  useEffect(() => {
    if (doctorListData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [doctorListData]);
  console.log("doctorListData", doctorListData?.data?.totalRecords);
  useEffect(() => {
    const payload = {
      pageNo: "1",
    };
    dispatch(doctorListInProgress(payload));
  }, [dispatch]);
  const [filteredUsers, setFilteredUsers] = useState("");
  const totalRecords = doctorListData?.data?.totalRecords;
  const handleSelectChange = (value) => {
    if (value === "all") {
      setFilteredUsers(doctorList);
    } else {
      const newData = doctorList.slice(0, value);
      setFilteredUsers(newData);
    }
  };
  const handlePage = (page) => {
    const payload = {
      pageNo: page,
    };
    dispatch(doctorListInProgress(payload));
  };
  return (
    <Card>
      <Row className="p-10 Add-button">
        <Col>
          <Typography className="header-tag">
            {<IntlMessages id={"Addnew.doctorList"} />}
          </Typography>
        </Col>
      </Row>
      <Spin indicator={antIcon} spinning={loading}>
        <TableComponent
          columns={columns}
          dataSource={filteredUsers ? filteredUsers : doctorList}
          rowselector={handleSelectChange}
          itemList={doctorList}
          filteredUsers={filteredUsers}
          setFilteredUsers={setFilteredUsers}
          pagination={{
            total: totalRecords,
            onChange: (page) => handlePage(page),
          }}
          field={"firstName"}
          documentTitle="Doctor List"
          disableTableHeaderButtons={true}
        />
      </Spin>
    </Card>
  );
};

export default DoctorList;
